export default "__VITE_ASSET__STNPSYs2__"